import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip, Stack } from '@mui/material';
import { hotlineBlocklistFields } from '../../hotlineBlocklist.model';

const HotlineStateField = ({ label = 'Applies To', ...props }) => {
    const record = useRecordContext();
    if (!record) return null;

    const appliesToTx = record[hotlineBlocklistFields.appliesToTx];
    const appliesToTn = record[hotlineBlocklistFields.appliesToTn];

    const chips = [];
    
    if (appliesToTx) {
        chips.push(
            <Chip 
                key="tx" 
                label="TX" 
                color="primary" 
                size="small"
                sx={{ mr: 0.5 }}
            />
        );
    }
    
    if (appliesToTn) {
        chips.push(
            <Chip 
                key="tn" 
                label="TN" 
                color="secondary" 
                size="small"
                sx={{ mr: 0.5 }}
            />
        );
    }

    if (chips.length === 0) {
        return <Chip label="None" color="default" size="small" />;
    }

    return (
        <Stack direction="row" spacing={0.5}>
            {chips}
        </Stack>
    );
};

export default HotlineStateField; 